import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})

export class AudaService
{
  private host : string = environment.callCenterWSBase;
  //private host : string = "https://localhost:32768";

  constructor(private http: HttpClient){}

  public instanciaAuda(token:string, matricula: string, bastidor: string){
    let url:string = this.host + "/AudaWSHistorico";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
      {
        parameters:
          [
            [
              {
                campo:"eurocode",
                operacion: "<>",
                valor: ''
              },
              {
                campo:"oem",
                operacion: "<>",
                valor: ''
              }
            ]
          ],
        select:["oem", "eurocode"]
      };

    if (matricula.toString().trim() !== ''){
      arrParams.parameters.push([
        {
          campo:"matricula",
          operacion:"=",
          valor:matricula.toString()
        }
      ]);
    }

    if(bastidor.toString().trim() !== ''){

      arrParams.parameters.push(
        [{
          campo:"vin",
          operacion:"=",
          valor:bastidor.toString()
        }]
      );
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res:any)
          {
            resolve(res);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          }
        });
    });
  }

  public buscarTablaAuda(token:string, matricula?: string, bastidor?: string):Promise<any>
  {
    let url:string = this.host + "/AudaWSHistorico/buscarArt";

    // Set the request headers with the authorization token
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrayParam = {
      "matricula": matricula,
      "bastidor": bastidor
    };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrayParam,httpOptions)
        .subscribe
        ({
          next(res:any)
          {
            resolve(res);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          }
        });
    });
  }
}


